'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _nyiAlert = require('../../../nyi-alert');

var _nyiAlert2 = _interopRequireDefault(_nyiAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.routes.admin.dashboard', ['ui.router', 'ngMaterial', 'ifeis.nyi']).config(function ($stateProvider) {
  $stateProvider.state('admin.dashboard', {
    url: '/dashboard',
    template: require('./tpl.html'),
    controller: 'AdminDashboardController',
    ncyBreadcrumb: {
      label: 'iFeis Administration'
    }
  });
}).run(function ($state, $rootScope) {
  $rootScope.$on('$stateChangeError', function (event, toState) {
    if (toState.name.indexOf('admin') === 0) {
      $state.go('not-authorized', {}, { location: false });
    }
  });
}).controller('AdminDashboardController', function ($scope, $mdDialog, $state, fNyiAlert, $mdSidenav) {
  function goFn(state) {
    return function goToState() {
      return $state.go('admin.' + state);
    };
  }

  $scope.tiles = [{
    label: 'Invitations',
    background: 'red',
    icon: 'plus-circle',
    flex: 50,
    go: goFn('invitations')
  }, { label: 'Finance', background: 'orange', icon: 'money' }, { label: 'Feiseanna', background: 'green', icon: 'list' }, { label: 'Personnel', background: 'indigo', icon: 'key' }, { label: 'Teachers', background: 'blue', icon: 'user' }, {
    label: 'Schools',
    background: 'pink',
    icon: 'graduation-cap',
    go: goFn('schools')
  }, {
    label: 'Adjudicators',
    background: 'purple',
    icon: 'gavel',
    go: goFn('adjudicators')
  }, {
    label: 'Manage Training Resources',
    background: 'red',
    icon: 'graduation-cap',
    go: goFn('trainings')
  }, {
    label: 'Edit Accounts',
    background: 'orange',
    icon: 'user',
    go: goFn('edit-accounts')
  }];

  $scope.tiles.forEach(function (tile) {
    if (!tile.go) {
      tile.go = function (event) {
        fNyiAlert(event);
      };
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/admin/dashboard/index.js
// module id = 512
// module chunks = 0